import { IEnvironment } from "./environment.interface";

const host = "https://api-dev.guestup.com/go-onsite-wallet/v1/fo";

export const environment: IEnvironment = {
  production: false,
  env: "DEV",
  apiURL: host
};
